import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <div className="w-full bg-gradient-to-r from-gray-800 to-gray-900 py-6 shadow-md">
      <div className="container px-4 mx-auto">
        <Link to="/" className="block w-fit mx-auto">
          <img 
            src="/brand/logo.png" 
            alt="भेडा कसम Logo" 
            className="h-14 md:h-16 w-auto"
          />
        </Link>
        <p className="text-lg text-gray-300 text-center font-medium mt-2">
          Tracking Political Promises in Nepal
        </p>
      </div>
    </div>
  );
};

export default Header;
